import React from 'react';
import { InviteComponent } from '../../components';

import './manager-invite.scss';
const ManagerInvite = () => {
  return (
    <div className="admin-manager-invite">
      <InviteComponent />
    </div>
  );
};

export default ManagerInvite;
